import { t } from '~/helpers/localization';

import type { CurrencyType } from '@wg/wows-react-uikit/components/Currency/Currency';

export const currencyNames: Record<CurrencyType & 'dublon', string> = {
  gold: t('Дублоны'),
  dublon: t('Дублоны'),
  oil: t('Нефть'),
  coal: t('Уголь'),
  steel: t('Сталь'),
  'silver-star': 'silver-star',
  'gold-star': 'gold-star',
  ribbon: t('Ленты'),
  damage: t('Урон'),
} as const;

export const currencyNamesToWE: Record<string, string> = {
  gold: 'gold',
  dublon: 'gold',
  oil: 'clan_resource',
  clan_resource: 'clan_resource',
  coal: 'coal',
  steel: 'steel',
};
